import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { FlexBetween } from '../../../../global/commonStyle';

const Box = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
`;

const Content = styled.div`
  padding: var(--space-20);
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  .input-field-wrapper {
    gap: var(--space-12);
    label {
      color: var(--text-primary);
    }
    input {
      color: var(--text-secondary);
    }
  }
`;

const Buttons = styled.div`
  ${FlexBetween}
`;

const SocialIcon = styled.div`
  display: flex;
  gap: var(--space-10);
  ${mobile_xl(css`
    gap: var(--space-12);
  `)}
`;
const Icon = styled.div`
  cursor: pointer;
  width: 24px;
  height: 24px;
  .social-icon {
    fill: var(--text-secondary);
    path {
      fill: var(--text-white);
    }
  }
  .facebook-icon {
    &:hover {
      fill: var(--brand-primary);
    }
  }
  .email-icon {
    &:hover {
      fill: var(--brand-primary);
    }
  }
  .twitter-icon {
    &:hover {
      fill: var(--brand-primary);
    }
  }
`;
const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  margin-bottom: var(--space-24);
  ${mobile_xl(css`
    margin-top: var(--space-8);
    gap: var(--space-12);
  `)}
`;
const Total = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: var(--space-16);
  ${mobile_xl(css`
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
    gap: var(--space-12);
  `)}
`;

export { Box, Content, Buttons, SocialIcon, Icon, Bottom, Total };
